import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import utc from 'dayjs/plugin/utc'
import { AiFillEdit } from "react-icons/ai";
import { API_URL } from "../../config";
import Tooltip from "@mui/material/Tooltip";
import DatePicker from "../../components/Datapicker";
import { LuCircleCheck, LuCircleX } from "react-icons/lu";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard25reportedit() {
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [selectedEditRowData1, setSelectedEditRowData1] = useState([]);
  const [user, setUser] = useState(null);
  const [open2, setOpen2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [defaultOption, setDefaultOption] = useState("");
  const [selectedUsers2, setSelectedUsers2] = useState([]);
  const [selectedUsers2p, setSelectedUsers2p] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [product, setProduct] = useState([]);
  const [coment, setComent] = useState('');
  const [searchQuery2, setSearchQuery2] = useState('');
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const getCurrentTime = () => dayjs().hour(8).minute(30).second(0).millisecond(0).format();
  const [startTime, setStartTime] = useState(getCurrentTime());
  const [endTime, setEndTime] = useState(getCurrentTime());
  const [defaultOption1, setDefaultOption1] = useState([]);
  const [defaultOption2, setDefaultOption2] = useState([]);
  const [defaultOption1m, setDefaultOption1m] = useState([]);
  const [defaultOption2u, setDefaultOption2u] = useState([]);
  const token = localStorage.getItem('jwtToken');
  const [product1, setProduct1] = useState([]);
  const [searchQuery3, setSearchQuery3] = useState('');
  const [selectedUsers3, setSelectedUsers3] = useState([]);
  const [selectedUsers3p, setSelectedUsers3p] = useState([]);
  const [showff, setShowff] = useState(false);
  const [survey, setSurvey] = useState([]);
  const [anssurvey, setansSurvey] = useState([]);
  const [anssurveyst, setansSurveyst] = useState([]);
  const [comments, setComments] = React.useState({});

  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const questionsResponse = await axios.get(`${API_URL}/api/surveyquestions`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        let questions = questionsResponse.data;

        if (selectedEditRowData?.report_detail_id) {
          const answersResponse = await axios.get(`${API_URL}/api/surveyanswers/${selectedEditRowData.report_detail_id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          const answers = answersResponse.data;

          const convertedAnsSurvey = answers.map(item => ({
            survey_questions_id: item.survey_questions_id,
            survey_answer: item.survey_answer ? 1 : 0,
            comment: item.comment || ""
          }));

          setansSurvey(convertedAnsSurvey);
          setansSurveyst(convertedAnsSurvey);

          const initialComments = {};
          answers.forEach(item => {
            if (item.comment) {
              initialComments[item.survey_questions_id] = item.comment;
            }
          });
          setComments(initialComments);

          questions = questions.map(item => {
            const matchedAnswer = answers.find(ans => ans.survey_questions_id === item.survey_questions_id);
            if (matchedAnswer) {
              return {
                ...item,
                answer: matchedAnswer.survey_answer ? 'Da' : 'Nu',
                comment: matchedAnswer.comment || ""
              };
            }
            return item;
          });
        }

        setSurvey(questions);
      } catch (error) {
        console.error("Eroare la preluarea datelor de sondaj:", error);
      }
    };

    fetchSurveyData();
  }, [selectedEditRowData]);

  const handleSurveyAnswer = (survey_questions_id, answer) => {
    const numericValue = answer === 'Da' ? 1 : 0;

    setansSurvey(prev => {
      const filtered = prev.filter(item => item.survey_questions_id !== survey_questions_id);
      return [...filtered, { survey_questions_id, survey_answer: numericValue }];
    });

    setSurvey(prevSurvey =>
      prevSurvey.map(item =>
        item.survey_questions_id === survey_questions_id
          ? { ...item, answer }
          : item
      )
    );
  };

  useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.userId]);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);

      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);


  useEffect(() => {
    if (selectedEditRowData) {
      setDefaultOption(selectedEditRowData?.user_id ? selectedEditRowData?.user_id : Data2[0]?.user_id);

      axios.post(`${API_URL}/api/report/details`, { report_detail_id: selectedEditRowData?.report_detail_id }, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      })
        .then(response => {
          const datarep = response.data.data[0]?.visits[0]?.reports[0]

          if (datarep.visit_date) {
            const formattedDatestart = dayjs.utc(datarep.visit_date).format("YYYY-MM-DD");
            setStartDate(formattedDatestart);
          }

          setSelectedEditRowData1(datarep);
          setComent(datarep.report_comment || "");

          const vvv = datarep.report_users_name.map((i) => i.report_user)
          const nnn = datarep.materials.map((i) => i.materials_id)
          const mmm = datarep.products.map((i) => i.product_id)
          const lll = datarep.report_pharmacist_ff.map((i) => i.pharmacist_id)
          setSelectedUsers3(lll)
          setSelectedUsers3p(lll)
          setDefaultOption2(vvv);
          setDefaultOption2u(vvv);
          setDefaultOption1(nnn);
          setDefaultOption1m(nnn);
          setSelectedUsers2(mmm);
          setSelectedUsers2p(mmm);

          if (datarep?.location?.id_inst === 1058) {
            setShowff(true)
            const medica_agent_adress_id = datarep?.location?.medica_agent_adress_id;
            if (medica_agent_adress_id) {
              axios.post(`${API_URL}/api/pharmacistff`, {
                medica_agent_adress_id: medica_agent_adress_id
              }, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
                .then(response => {
                  setProduct1(response.data);
                })
                .catch(error => console.error(error));
            }
          }
          setData2([{
            user_id: datarep.user_id,
            start_time: datarep.report_start_time,
            end_time: datarep.report_end_time,
            obiect_id: datarep?.object_id ?? null,
            index: 1,
            obiect_type_id: datarep?.obiect_type_id ?? null,
            comment: datarep.comment || "",
            planning_detail_id: datarep?.planning_detail_id ?? null,
            report_detail_id: datarep?.report_detail_id ?? null,
            status: datarep?.planning_type_id === 1 ? "Planificat" : "Neplanificat",
            institution_id: datarep?.location?.institution_id ?? null,
            institution: datarep?.location?.institution ?? null,
            address: datarep?.location?.address ?? null,
            city_name: datarep?.location?.city ?? null,
            inst_type: datarep?.location?.inst_type ?? null,
            physician_name: datarep?.physician?.name ?? null,
            data_acord: datarep?.physician?.data_acord ?? null,
            speciality: datarep?.physician?.speciality ?? null,
            is_double_visit: datarep?.is_double_visit ?? null
          }]);
        })
        .catch(err => console.error(err));
    }
  }, [selectedEditRowData]);

  useEffect(() => {
    if (!user?.userId) return;

    const fetchMaterials = axios.get(`${API_URL}/api/materials`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const fetchProduct = axios.post(
      `${API_URL}/api/productuser`,
      { user_id: user?.userId || 0 },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const fetchManageUsers = axios.post(
      `${API_URL}/api/users/manageusers`,
      { user_id: user?.userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Promise.all([fetchMaterials, fetchProduct, fetchManageUsers])
      .then(([materialsRes, productRes, manageUsersRes]) => {
        const materials = materialsRes.data.filter((i) => i.is_active !== 0);
        setMaterials(materials);
        setProduct(productRes.data);
        setData1(manageUsersRes.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user, token]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      handleOpenRows2();
    }
  }, [selecteddeleteuser1]);

  const handleOpenRows2 = () => {
    setOpen2(true);
    const startTimeFormatted = dayjs.utc(selecteddeleteuser1.start_time);
    const endTimeFormatted = dayjs.utc(selecteddeleteuser1.end_time);
    setStartTime(startTimeFormatted);
    setEndTime(endTimeFormatted);
  };

  const handleToggleUser2 = (userId) => {
    setSelectedUsers2((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleToggleUser3 = (userId) => {
    setSelectedUsers3((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSave2 = async () => {
    setData2((prevData) => {
      const updatedData = prevData.map((entry) => {
        if (entry.index === selecteddeleteuser1.index) {
          const newStartTime = startTime;
          const newEndTime = endTime;

          return {
            ...entry,
            start_time: newStartTime,
            end_time: newEndTime,
          };
        }
        return entry;
      });
      return updatedData;
    });

    setSelecteddeleteuser1("");
    setOpen2(false);
  };

  const handleButtonClick2 = async () => {
    setIsLoading(true);
    try {
      await handleSave2();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    try {

      const requests = Data2
        .map(({ start_time, end_time }) => ({
          user_id: defaultOption ? defaultOption : user.userId,
          start_time,
          end_time,
          visit_date: startDate,
          comment: coment,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          planning_id: selectedEditRowData?.planning_id
        }));

      if (requests.length > 0) {
        await axios.put(`${API_URL}/api/changeplanreport`, requests);
      }

      const requests1 = (defaultOption1 || [])
        .filter(id => !(defaultOption1m || []).includes(id))
        .flatMap((id) => ({
          materials_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          is_active: 1,
          user_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));
      ;

      const requests2 = (selectedUsers2 || [])
        .filter(id => !(selectedUsers2p || []).includes(id))
        .flatMap((id) => ({
          product_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          is_active: 1,
          user_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const requests3 = (defaultOption2 || [])
        .filter(id => !(defaultOption2u || []).includes(id))
        .flatMap((id) => ({
          user_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          is_active: 1,
          submiteduser_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const requests5 = (selectedUsers3 || [])
        .filter(id => !(selectedUsers3p || []).includes(id))
        .flatMap((id) => ({
          pharmacist_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          submiteduser_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));
      let allRequests5 = [];
      if (anssurvey?.length) {
        const surveyPayload = anssurvey
          .filter(current => {
            const original = anssurveyst.find(
              prev => prev.survey_questions_id === current.survey_questions_id
            );

            if (!original) return true;

            const currentAnswer = (current.survey_answer === 'Da' || current.survey_answer === 1) ? 1 : 0;
            const originalAnswer = original.survey_answer ? 1 : 0;

            const currentComment = comments[current.survey_questions_id] || current.comment || "";
            const originalComment = original.comment || "";

            return (
              currentAnswer !== originalAnswer ||
              currentComment !== originalComment
            );
          })
          .map(ans => ({
            survey_questions_id: ans.survey_questions_id,
            report_detail_id: selectedEditRowData1?.report_detail_id,
            planning_id: selectedEditRowData.planning_id,
            submiteduser_id: user?.userId,
            survey_answer: (ans.survey_answer === 'Da' || ans.survey_answer === 1) ? 1 : 0,
            comment: comments[ans.survey_questions_id] || ans.comment || null
          }));

        if (surveyPayload.length > 0) {
          allRequests5.push(...surveyPayload);
        }
      }
      const deleteRequests1 = (defaultOption1m || [])
        .filter(id => !(defaultOption1 || []).includes(id))
        .map(id => ({
          materials_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          user_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const deleteRequests2 = (selectedUsers2p || [])
        .filter(id => !(selectedUsers2 || []).includes(id))
        .map(id => ({
          product_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          user_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const deleteRequests3 = (defaultOption2u || [])
        .filter(id => !(defaultOption2 || []).includes(id))
        .map(id => ({
          user_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          submiteduser_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const deleteRequests5 = (selectedUsers3p || [])
        .filter(id => !(selectedUsers3 || []).includes(id))
        .map(id => ({
          pharmacist_id: id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          submiteduser_id: user?.userId,
          planning_id: selectedEditRowData?.planning_id
        }));

      const deleteallRequests5 = (anssurveyst || [])
        .filter(original => {
          const current = (anssurvey || []).find(
            curr => curr.survey_questions_id === original.survey_questions_id && curr.survey_answer === original.survey_answer
          );

          return !current ||
            (current.survey_answer === null ||
              current.survey_answer === undefined ||
              current.survey_answer === '');
        })
        .map(original => ({
          survey_questions_id: original.survey_questions_id,
          report_detail_id: selectedEditRowData1?.report_detail_id,
          planning_id: selectedEditRowData?.planning_id,
          user_id: user?.userId,
          survey_answer: original.survey_answer
        }));

      await Promise.all([
        requests1.length > 0 && axios.post(`${API_URL}/api/reportmaterials`, requests1),
        requests2.length > 0 && axios.post(`${API_URL}/api/reportproducts`, requests2),
        requests3.length > 0 && axios.post(`${API_URL}/api/reportdoublevisits`, requests3),
        requests5.length > 0 && axios.post(`${API_URL}/api/reportpharmacistff`, requests5),
        allRequests5.length > 0 && axios.post(`${API_URL}/api/surveyanswers`, allRequests5),

        deleteRequests2.length > 0 && axios.put(`${API_URL}/api/deletereportproducts`, deleteRequests2),
        deleteRequests1.length > 0 && axios.put(`${API_URL}/api/deletereportpmaterials`, deleteRequests1),
        deleteRequests3.length > 0 && axios.put(`${API_URL}/api/deletereportdoublevisits`, deleteRequests3),
        deleteRequests5.length > 0 && axios.put(`${API_URL}/api/deletereportpharmacistff`, deleteRequests5),
        deleteallRequests5.length > 0 && axios.put(`${API_URL}/api/deletesurveyanswers`, deleteallRequests5),
      ]);

      handleSuccess();
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      fetch(`${API_URL}/api/send-error`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          error: error.message,
          stack: error.stack,
          componentStack: `DashbordCard25reportedit | UserID: ${user?.userId}`,
        }),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    showToast({
      message: "Datele au fost salvate cu succes!",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
    });
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const dropdownOptions = Data1.map((region) => ({
    value: region.user_id,
    label: region.user_name_surname
  }));

  const _onSelect = (selectedOption) => {
    setDefaultOption(selectedOption);
  };

  const dropdownOptions1 = materials.map((region) => ({
    value: region.materials_id,
    label: region.description
  }));

  const _onSelect1 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption1((prev) => [...prev, value]);
    } else {
      setDefaultOption1((prev) => prev.filter((item) => item !== value));
    }
  };

  const _onSelect2 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption2((prev) => [...prev, value]);
    } else {
      setDefaultOption2((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleStartTimeChange = (e) => {
    const selected = e.target.value;
    const today = dayjs().format("YYYY-MM-DD");
    const newStartUTC = dayjs.utc(`${today}T${selected}`).toISOString();

    if (endTime &&
      dayjs.utc(newStartUTC).isAfter(dayjs.utc(endTime).subtract(5, "minute"))
    ) {
      const bumpedEnd = dayjs.utc(newStartUTC).add(5, "minute").toISOString();
      setEndTime(bumpedEnd);
    }

    setStartTime(newStartUTC);
  };

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')

  const handleEndTimeChange = (e) => {
    const selected = e.target.value;
    const today = dayjs().format("YYYY-MM-DD");
    const newEndUTC = dayjs.utc(`${today}T${selected}`).toISOString();

    if (startTime && dayjs.utc(newEndUTC).isBefore(dayjs.utc(startTime))) {
      setErrorMessage(`Ora de sfârșit nu poate fi mai mică decât ora de start (${dayjs.utc(startTime).format('HH:mm')})`);
      setShowError(true);
      setEndTime(newEndUTC);
    } else {
      setEndTime(newEndUTC);
      setShowError(false);
    }
  };

  // const handleEndTimeChange = (e) => {
  //   const selected = e.target.value;
  //   const today = dayjs().format("YYYY-MM-DD");
  //   const newEndUTC = dayjs.utc(`${today}T${selected}`).toISOString();

  //   if (startTime &&
  //     dayjs.utc(newEndUTC).isBefore(dayjs.utc(startTime).add(5, "minute"))
  //   ) {
  //     const minEnd = dayjs.utc(startTime).add(5, "minute").toISOString();
  //     setEndTime(minEnd);
  //   } else {
  //     setEndTime(newEndUTC);
  //   }
  // };

  const fmtHM = dt => dayjs.utc(dt).format("HH:mm");
  // const minEnd = startTime ? fmtHM(dayjs.utc(startTime).add(5, "minute")) : undefined;
  // const maxStart = endTime ? fmtHM(dayjs.utc(endTime).subtract(5, "minute")) : undefined;

  const handleChangecom = (event) => {
    setComent(event.target.value);
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">

          <div className="col-span-full  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                  action={user.role !== 'User' && (
                    <div className="relative mt-4">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10">Utilizator</label>
                      <select
                        className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                        value={defaultOption}
                        onChange={(e) => _onSelect(e.target.value)}
                        disabled={true}

                      >
                        <option value="" disabled>Alege utilizator</option>
                        {dropdownOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  )} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex gap-2">
                      <div className="relative w-full">
                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                          Data
                        </label>
                        <DatePicker
                          selectedDate={startDate}
                          handleDateChange={handleStartDateChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="relative mt-4">
                    <Divider className="dark:bg-gray-400" />
                    <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
                      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Raportae detalii</h2>
                      <h2 className="font-medium text-gray-600 dark:text-gray-300">{Data2[0]?.is_double_visit ? 'Vizita Dubla/' : ""}{Data2[0]?.status}</h2>
                    </header>

                    <div className="p-3 max-xs:sr-only">
                      <div className="lg:flex w-full">
                        <div className="w-full overflow-x-auto">
                          <table className="w-full table-auto whitespace-nowrap">
                            <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                              <tr>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Interval ora</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Doctor</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Specialitatea</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Tip</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Institutia</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Adresa</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Oras</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                              {Data2.map((item, idx) => {
                                return (
                                  <React.Fragment key={idx}>
                                    <tr className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                      <td className="p-2 whitespace-nowrap flex items-center">
                                        {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                          ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                            <span>{item.start_time} - {item.end_time}</span>)}
                                        <div
                                          className="font-semibold text-center"
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                          }}
                                        >
                                          <Tooltip title="Editeaza" arrow placement="top">
                                            <IconButton
                                              onClick={() => setSelecteddeleteuser1(item)}
                                              color="primary"
                                              sx={{
                                                fontSize: "16px",
                                                borderRadius: "50%",
                                                "&:hover": {
                                                  backgroundColor: "#a4adad",
                                                },
                                              }}
                                            >
                                              <AiFillEdit className="dark:text-gray-100" />
                                              <Transition appear show={open2} as={Fragment}>
                                                <Dialog as="div" className="relative z-10" onClose={() => setOpen2(false)}>
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0"
                                                    enterTo="opacity-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100"
                                                    leaveTo="opacity-0"
                                                  >
                                                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                                                  </Transition.Child>

                                                  <div className="fixed inset-0 overflow-y-auto">
                                                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                      <Transition.Child
                                                        as={Fragment}
                                                        enter="ease-out duration-300"
                                                        enterFrom="opacity-0 scale-95"
                                                        enterTo="opacity-100 scale-100"
                                                        leave="ease-in duration-200"
                                                        leaveFrom="opacity-100 scale-100"
                                                        leaveTo="opacity-0 scale-95"
                                                      >
                                                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                                            Selectează Ora
                                                          </Dialog.Title>
                                                          <div className="mt-4">
                                                            <form className="max-w-[16rem] mx-auto grid grid-cols-2 gap-4">
                                                              <div>
                                                                <label htmlFor="start-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                  Start ora:
                                                                </label>
                                                                <div className="relative">
                                                                  <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                    <svg
                                                                      className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                      aria-hidden="true"
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      fill="currentColor"
                                                                      viewBox="0 0 24 24"
                                                                    >
                                                                      <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd" />
                                                                    </svg>
                                                                  </div>
                                                                  <input
                                                                    type="time"
                                                                    id="start-time"
                                                                    className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                    value={startTime ? dayjs.utc(startTime, "HH:mm").format("HH:mm") : ""}
                                                                    onChange={handleStartTimeChange}
                                                                    name="appt" min="09:00"
                                                                    // max={maxStart}
                                                                    required />
                                                                </div>
                                                              </div>
                                                              <div>
                                                                <label htmlFor="end-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                  End ora:
                                                                </label>
                                                                <div className="relative">
                                                                  <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                    <svg
                                                                      className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                      aria-hidden="true"
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      fill="currentColor"
                                                                      viewBox="0 0 24 24"
                                                                    >
                                                                      <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd" />
                                                                    </svg>
                                                                  </div>
                                                                  <input
                                                                    type="time"
                                                                    id="end-time"
                                                                    className={`bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${showError ? 'border-red-500' : ''
                                                                      }`} value={endTime ? dayjs.utc(endTime, "HH:mm").format("HH:mm") : ""}
                                                                    // min={minEnd}
                                                                    onChange={handleEndTimeChange}
                                                                    required />
                                                                </div>
                                                              </div>
                                                            </form>
                                                            {showError && (
                                                              <p className="mt-1 text-sm text-red-600 flex items-center">
                                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                                </svg>
                                                                {errorMessage}
                                                              </p>
                                                            )}
                                                          </div>

                                                          <div className="mt-4 flex justify-end gap-2">
                                                            <button
                                                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                              onClick={() => { setOpen2(false); setSelecteddeleteuser1("") }}
                                                            >
                                                              Anulează
                                                            </button>

                                                            <button
                                                              className={`btn ${isLoading
                                                                ? "bg-gray-500 text-gray-300"
                                                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                              onClick={handleButtonClick2}
                                                              disabled={isLoading}
                                                            >
                                                              {isLoading ? (
                                                                <svg
                                                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                                                  width="16"
                                                                  height="16"
                                                                  viewBox="0 0 16 16"
                                                                >
                                                                  <circle
                                                                    className="opacity-25"
                                                                    cx="8"
                                                                    cy="8"
                                                                    r="7"
                                                                    stroke="currentColor"
                                                                    strokeWidth="2" />
                                                                  <path
                                                                    className="opacity-75"
                                                                    d="M12 2a6 6 0 000 12V2z" />
                                                                </svg>
                                                              ) : (
                                                                <svg
                                                                  className="fill-current shrink-0 xs:hidden"
                                                                  width="16"
                                                                  height="16"
                                                                  viewBox="0 0 16 16"
                                                                >
                                                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                                </svg>
                                                              )}
                                                              <span className="//max-xs:sr-only">
                                                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                              </span>
                                                            </button>
                                                          </div>
                                                        </Dialog.Panel>
                                                      </Transition.Child>
                                                    </div>
                                                  </div>
                                                </Dialog>
                                              </Transition>
                                            </IconButton>
                                          </Tooltip>
                                        </div>
                                      </td>
                                      <td className="p-2 whitespace-nowrap">
                                        {item.obiect_type_id === 1 ? (
                                          <div className="flex items-center gap-1.5">
                                            <span>{item.physician_name || "-"}</span>
                                            {item.data_acord ? (
                                              <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                </svg>
                                              </span>
                                            ) : null}
                                          </div>
                                        ) : "-"}
                                      </td>
                                      <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? item.speciality || "-" : "-"}</td>
                                      <td className="p-2 whitespace-nowrap">{item.inst_type}</td>
                                      <td className="p-2 whitespace-nowrap">{item.institution}</td>
                                      <td className="p-2 whitespace-nowrap">{item.address}</td>
                                      <td className="p-2 whitespace-nowrap">{item.city_name}</td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <table className="w-full">
                      <tbody>
                        {Data2.map((item, idx) => {
                          return (
                            <React.Fragment key={idx}>
                              <tr>
                                <td>
                                  <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                    <div className="grid grid-cols-1 gap-2">
                                      <div className="flex items-center gap-2 p-2">
                                        <div>
                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-600 dark:text-gray-300">Interval ora: </span>

                                            {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                              ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                <span>{item.start_time} - {item.end_time}</span>)}
                                            <div
                                              className="font-semibold text-center"
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "20px",
                                              }}
                                            >
                                              <Tooltip title="Editeaza" arrow placement="top">
                                                <IconButton
                                                  onClick={() => setSelecteddeleteuser1(item)}
                                                  color="primary"
                                                  sx={{
                                                    fontSize: "16px",
                                                    borderRadius: "50%",
                                                    "&:hover": {
                                                      backgroundColor: "#a4adad",
                                                    },
                                                  }}
                                                >
                                                  <AiFillEdit className="dark:text-gray-100" />

                                                </IconButton>
                                              </Tooltip>
                                            </div>
                                          </div>


                                          <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                            {item.obiect_type_id === 1 ? (
                                              <>
                                                <span>{item.physician_name}</span>
                                                {item.data_acord ? (
                                                  <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                    </svg>
                                                  </span>
                                                ) : null}
                                              </>
                                            ) : item.institution}
                                          </h3>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.inst_type}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.obiect_type_id === 1 ? (item.speciality + " - " + item.institution) || "-" : null}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {(item.address + " - " + item.city_name) || "-"}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="flex-1  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Participanți la vizită" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative space-y-2 mt-4 max-h-[220px] overflow-y-auto">
                    {dropdownOptions.map((option) => (
                      <div key={option.value} className="flex items-center  ml-4">
                        <input
                          type="checkbox"
                          id={option.value}
                          value={option.value}
                          checked={defaultOption2.includes(Number(option.value))}
                          onChange={(e) => _onSelect2(option.value, e.target.checked)}
                          className="ml-2 mr-2" />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="flex-1 rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Materiale" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    {dropdownOptions1.map((option) => (
                      <div key={option.value} className="flex items-center">
                        <input
                          type="checkbox"
                          id={option.value}
                          value={option.value}
                          checked={defaultOption1.includes(option.value)}
                          onChange={(e) => _onSelect1(option.value, e.target.checked)}
                          className="mr-2" />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          {(Data2[0]?.obiect_type_id === 2 && showff === true) && (
            <div className="flex-2 rounded-xl ">
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                  <CardHeader subheader="Informatia poate fii modificata" title="Cadre instruite FF" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                  <Divider className="dark:bg-gray-400" />
                  <CardContent>
                    <div className="relative mt-4">
                      <div className="mt-2">
                        <input
                          type="text"
                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                          placeholder="Căutare Farmacist"
                          value={searchQuery3}
                          onChange={(e) => setSearchQuery3(e.target.value)} />
                      </div>

                      <div className="mt-4 max-h-[164px] overflow-y-auto">
                        <ul>
                          {product1.filter((user) => {
                            return (
                              user.user_name_surname.toLowerCase().includes(searchQuery3.toLowerCase()) ||
                              user.description.toLowerCase().includes(searchQuery3.toLowerCase())
                            );
                          }).map((user) => {
                            return (
                              <li key={user.pharmacist_id} className="flex items-center gap-2 p-2 border-b">
                                <input
                                  type="checkbox"
                                  className="h-4 w-4"
                                  checked={selectedUsers3.includes(user.pharmacist_id)}
                                  onChange={() => handleToggleUser3(user.pharmacist_id, "physician")} />
                                <div>
                                  <div className="pl-4 flex flex-col">
                                    <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                      <span>{user.user_name_surname}</span>
                                      {(user.data_acord === 1 || user.data_acord === true) && (
                                        <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                          <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      )}
                                    </h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.description}</p>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </form>
            </div>
          )}



          <div
            className={`${(Data2[0]?.obiect_type_id === 2 && showff === true) ? 'flex-1 col-span-full rounded-xl' : 'flex-1 rounded-xl'}`}
          >
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Produse" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <div className="mt-4">
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                        placeholder="Căutare Produs"
                        value={searchQuery2}
                        onChange={(e) => setSearchQuery2(e.target.value)} />
                    </div>

                    <div className="mt-4 max-h-[164px] overflow-y-auto">
                      <ul>
                        {product.filter((user) => {
                          return (
                            user.description.toLowerCase().includes(searchQuery2.toLowerCase())
                          );
                        }).map((user, index) => {
                          return (
                            <li key={`${user.product_id}-${user.user_id}-${index}`} className="flex items-center gap-2 p-2 border-b">
                              <input
                                type="checkbox"
                                className="h-4 w-4"
                                checked={selectedUsers2.includes(user.product_id)}
                                onChange={() => handleToggleUser2(user.product_id, "physician")} />
                              <div>
                                <div className="pl-4 flex items-center justify-between">
                                  <h3 className="text-gray-900 dark:text-gray-100">{user.description}</h3>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="col-span-full rounded-xl">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader
                  subheader="Informatia poate fii modificata"
                  title="Chestionar"
                  subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <div className="relative mt-2 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm sticky top-0">
                          <tr>
                            <th scope="col" className="text-left p-2 font-semibold">Întrebare</th>
                            <th scope="col" className="text-center p-2 font-semibold">Da</th>
                            <th scope="col" className="text-center p-2 font-semibold">Nu</th>
                          </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                          {survey.filter((i) => i.survey_questions_type_id === (selectedEditRowData.obiect_type_id === 1 ? 1 : 2))
                            .map((user, idx) => (
                              <React.Fragment key={user.survey_questions_id}>
                                <tr className={`text-sm ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                  <td className="px-4 py-1 whitespace-normal">
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.survey_questions}</p>
                                    {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && (
                                      <p className="text-xs text-gray-500 dark:text-gray-300">
                                        Dacă ați selectat „Da”, completați caseta cu un comentariu.
                                      </p>
                                    )}
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      onClick={() => handleSurveyAnswer(user.survey_questions_id, 'Da')}
                                      className={`p-1 rounded-full ${user.answer === 'Da' ? 'text-green-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Da"
                                    >
                                      <LuCircleCheck className="h-5 w-5" />
                                    </button>
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      onClick={() => handleSurveyAnswer(user.survey_questions_id, 'Nu')}
                                      className={`p-1 rounded-full ${user.answer === 'Nu' ? 'text-red-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Nu"
                                    >
                                      <LuCircleX className="h-5 w-5" />
                                    </button>
                                  </td>
                                </tr>

                                {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && user.answer === 'Da' && (
                                  <tr>
                                    <td colSpan={3}>
                                      <form onSubmit={(e) => e.preventDefault()}>
                                        <Card className="p-0 dark:bg-gray-800 dark:text-gray-100">
                                          <CardContent className="p-0">
                                            <div className="relative">
                                              <textarea
                                                id="message"
                                                rows="2"
                                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="Scrie aici..."
                                                value={comments[user.survey_questions_id] || ''}
                                                onChange={(e) =>
                                                  setComments(prev => ({
                                                    ...prev,
                                                    [user.survey_questions_id]: e.target.value
                                                  }))
                                                }
                                              />
                                            </div>
                                          </CardContent>

                                        </Card>
                                      </form>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardContent>
              </Card>


            </form>
          </div>

          <div className="col-span-full rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Comentariu" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <textarea
                      id="message"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Scrie aici..."
                      value={coment}
                      onChange={handleChangecom} />
                  </div>
                </CardContent>
                <Divider className="dark:bg-gray-400" />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                  <button
                    className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white flex items-center gap-2"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                      </svg>
                    ) : (
                      <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                    )}
                    <span className="//max-xs:sr-only">{loading ? "Se salvează..." : "Salvează detaliile"}</span>
                  </button>
                </CardActions>
              </Card>
            </form>
          </div>

        </div>
      )}
    </div>
  );
}

export default DashboardCard25reportedit;